import styled from 'styled-components'

export const ProjectLogoImage = styled.img`
  height: 200px;
  width: 400px;
  object-fit: contain;
`
